module.exports = __webpack_public_path__ + "static/img/products application_pool3.fd4e3797.jpg";